import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, boolean, object, string } from "yup";
import "Forms/Schemas/customMethods";

export type HousingExpenseFormType = {
  readonly aggregatedAmount?: string;
  readonly detailed?: boolean;
  readonly rent?: string;
  readonly rentName?: string;
  readonly electricity?: string;
  readonly electricityName?: string;
  readonly gas?: string;
  readonly gasName?: string;
  readonly water?: string;
  readonly waterName?: string;
  readonly customItems?: { name?: string; value?: string }[];
};

export const getHousingExpenseFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<HousingExpenseFormType> = (t) => {
  const customItemSchema = object({
    name: string().required(t(Resources.Validation.Required)),
    value: string()
      .required(t(Resources.Validation.Required))
      .greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 })),
  });

  return object({
    detailed: boolean().optional(),
    aggregatedAmount: string().when(["detailed"], ([detailed], schema) =>
      !detailed
        ? schema.required(t(Resources.Validation.Required)).greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 }))
        : schema.optional(),
    ),
    rent: string().optional(),
    rentName: string().optional(),
    electricity: string().optional(),
    electricityName: string().optional(),
    gas: string().optional(),
    gasName: string().optional(),
    water: string().optional(),
    waterName: string().optional(),
    customItems: array().when(["detailed"], ([detailed], schema) => {
      return detailed ? schema.of(customItemSchema).optional() : schema.optional().nullable();
    }),
  }).defined();
};
